export const METATAGS = {
  TITLE: 'Buy GOMO SIM Card - Sign up for a No-Contract Mobile Plan',
  DESCRIPTION:
    'Sign up a GOMO Mobile Plan in 4 easy steps. Fuss-free sign-up online. Get a new number or port-in your existing number now!',
  KEYWORDS:
    'gomo sim card, gomo number, no contract sim, gomo new number, buy gomo, buy gomo sim, gomo sim, gomo choose number, gomo port in'
};
